/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Sc_LeadInputs */

const en_mk_tut_sc_lead = /** @type {(inputs: Mk_Tut_Sc_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The shortcuts that exist in the product today. A \`G\` chord means: press \`G\`, release, then press the second letter.`)
};

const id_mk_tut_sc_lead = /** @type {(inputs: Mk_Tut_Sc_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pintasan yang ada di produk hari ini. Chord \`G\` berarti: tekan \`G\`, lepas, lalu tekan huruf keduanya.`)
};

/**
* | output |
* | --- |
* | "The shortcuts that exist in the product today. A `G` chord means: press `G`, release, then press the second letter." |
*
* @param {Mk_Tut_Sc_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_sc_lead = /** @type {((inputs?: Mk_Tut_Sc_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Sc_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_sc_lead(inputs)
	return en_mk_tut_sc_lead(inputs)
});